import {
  forwardRef,
  type MouseEventHandler,
  type ReactNode,
} from "react";

import { Icon } from "@focus/focusUI";

type Props = {
  title: string;
  icon?: string;
  controls: ReactNode;
  onMouseDownCapture?: MouseEventHandler<HTMLDivElement>;
};

export const FloatingWindowHeader =
  forwardRef<HTMLDivElement, Props>(
    (
      {
        title,
        icon,
        controls,
        onMouseDownCapture,
      },
      ref,
    ) => {
      return (
        <div
          ref={ref}
          onMouseDownCapture={onMouseDownCapture}
          onDragStart={(event) => event.preventDefault()}
          className="floating-window-header flex cursor-move select-none items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-2"
        >
          <div className="flex min-w-0 items-center gap-2">
            {icon && (
              <Icon
                icon={icon}
                title={false}
              />
            )}

            <span className="truncate font-semibold text-slate-900">
              {title}
            </span>
          </div>

          {controls}
        </div>
      );
    },
  );

FloatingWindowHeader.displayName =
  "FloatingWindowHeader";
